<template>
  <div>
    <b-row>
      <client-creator @newClient="clientChosen"></client-creator>
    </b-row>
    <b-row>
      <b-button
        @click="openGuestSeller"
        variant="success"
        class="w-auto m-auto"
      >
        Разова послуга
        <b-icon class="ms-1" icon="cart-check-fill"></b-icon>
      </b-button>
    </b-row>
    <b-row class="mt-3">
      <client-search-bar @clientChosen="clientChosen"></client-search-bar>
    </b-row>
  </div>
</template>

<script>
import ClientCreator from "@/components/modals/ClientCreator";
import ClientSearchBar from "@/components/ClientPage/ClientSearchBar";

export default {
  name: "ClientSidebar",
  components: {
    ClientSearchBar,
    ClientCreator,
  },
  methods: {
    clientChosen(id) {
      this.$emit("clientChosen", id);
    },
    openGuestSeller() {
      this.$emit("openSeller", null);
    },
  },
};
</script>

<style scoped></style>
